import React from "react";
import useRegion from "../../../../hooks/super/useRegion";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function DeleteRegionModal({ open, handleClose, id, name, removeFlag }) {
  const { deleteRegion } = useRegion();
  const [busy, setBusy] = React.useState(false);

  const title = removeFlag ? "Permanently remove region?" : "Delete region?";
  const body = removeFlag
    ? "This will permanently remove the WAF endpoint and cannot be undone."
    : "The region will be marked deleted. You can restore it later.";

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await deleteRegion(id, removeFlag);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="danger"
      title={title}
      body={body}
      items={id ? [{ id, title: name }] : []}
      submitLabel={removeFlag ? "Remove permanently" : "Delete"}
      loading={busy}
    />
  );
}

export default DeleteRegionModal;
